<template>
    <div>
        <Banner/>
        <!--城市级绿色出行服务平台-->
        <div class="city">
            <div class="city_img">
                <img src="@/asstes/solution/fourth.png" style="width: 100%;">
            </div>
            <div class="city_info">
                <div class="city_info_title">城市级绿色出行服务平台</div>
                <div class="city_info_subtitle"></div>
                <div class="city_info_pgh">
                    个人出行、公共交通出行、自主低碳出行、绿色定制出行<br/>
                    <br/>
                    打造节能、高效、可持续发展的域市绿色出行交通解决方案，通过对现有城市电动汽车运营网络的集中式平台化运营和管理，实现城市能源友好、环境友好和居民出行友好交通模式的有机结合，进一步实现城市交通的经济可持续性、社会可持续性和环境可持续性发展。</div>
<!--                <div class="city_info_more" @click="greenCityMore">了解更多</div>-->
            </div>
        </div>

        <div class="infoList">
            <div class="infoList_title">① 绿色出行平台系统</div>
            <div class="infoList_pgh">
                充分整合政府桩点，充分整合社会资源使用，积极推动、企业和社会三方合作，支持使用平台的全平台支持，统一使用社区，
                电动汽车桩、网路互联向公众提供标准、便利快捷的优质充电服务。
            </div>
            <div class="infoList_subtitle">
                主要功能：运营管理、抢修管理、运维巡视、充电设施、公交信息、用户中心
            </div>
            <div class="infoList_title">②分时租赁平台系统</div>
            <div class="infoList_pgh">
                提供优质的绿色短途出行服务，以小时或分钟等较短的时间单元（辅以里程等）计算费用，提供新能源汽车随取随用服务。 贯彻绿色出行理念，打造随时起租、随时停租的电动汽车共享平台。
            </div>
            <div class="infoList_subtitle">
                主要功能：客户管理、报表管理、网点/桩/车辆管理、订单管理、权限管理体系
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from './banner'
    export default {
        components: {
            Banner
        },
    }
</script>

<style lang="less" scoped>

    @media only screen and (max-width: 750px){
        .city{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding:  216px 144px 0 144px;
            box-sizing: border-box;

            .city_img{
                width: 100%;
                img{
                    width: 100%;
                }
            }
            .city_info{
                padding-top: 180px;
                box-sizing: border-box;

                .city_info_title{
                    font-weight: 600;
                    color: #373A5A;
                    font-size: 79.2px;
                    padding-bottom: 86.4px;
                    box-sizing: border-box;
                }
                .city_info_pgh{
                    text-align: left;
                    font-size: 50.4px;
                    line-height: 90px;
                    padding-bottom: 72px;
                    box-sizing: border-box;
                }
                .city_info_more{
                    text-align: left;
                    font-weight: 500;
                    color: #07CFA2;
                    font-size: 43.2px;
                    line-height: 57.6px;
                }
            }
        }

        .infoList{
            padding: 0 144px;
            box-sizing: border-box;
            font-size: 50.8px;
            .infoList_title{
                font-weight: 600;
                padding-bottom: 48px;
                box-sizing: border-box;
            }
            .infoList_pgh{
                font-weight: 400;
                line-height: 86.4px;
                padding-bottom: 120px;
                box-sizing: border-box;
            }
            .infoList_subtitle{
                color: #07CFA2;
                padding-bottom: 160px;
                box-sizing: border-box;
            }
        }
    }

    @media only screen and (min-width: 750px) {
        .city{
            padding: 48px 120px 90px 120px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;

            .city_img{
                width: calc(100% - 100px - 400px);
                padding-right: 100px;
                box-sizing: border-box;
            }

            .city_info{
                color: #373A5A;

                .city_info_title{
                    max-width: 400px;
                    font-size: 36px;
                    font-weight: 600;
                    line-height: 50px;
                    padding-bottom: 32px;
                    box-sizing: border-box;
                }
                .city_info_subtitle, .city_info_pgh{
                    max-width: 400px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 29px;
                }
                .city_info_subtitle{
                    font-size: 15px;
                    padding-bottom: 24px;
                    box-sizing: border-box;
                }
                .city_info_pgh{
                    font-size: 12px;
                    padding-bottom: 24px;
                    box-sizing: border-box;
                }
                .city_info_more{
                    font-size: 12px;
                    color: #07CFA2;
                }
                .city_info_more:hover{
                    cursor: pointer;
                }
            }
        }

        .infoList{
            color: #000;
            padding: 24px 120px;
            box-sizing: border-box;

            .infoList_title{
                font-size: 20px;
                padding-bottom: 32px;
                font-weight: 600;
            }

            .infoList_pgh{
                font-size: 15px;
                line-height: 28px;
                padding-bottom: 40px;
                box-sizing: border-box;
            }

            .infoList_subtitle{
                font-size: 15px;
                color: #07CFA2;
                padding-bottom: 48px;
                box-sizing: border-box;
            }
        }
    }



</style>